"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.extensionsToFilter = void 0;
const extensionsToFilter = exports.extensionsToFilter = ["csv", "xls", "xlsx", "doc", "docx"];
//# sourceMappingURL=extensionsToFilter.js.map